<template>
  <v-app id="inspire" :style="{'background-image': 'url(' + require('@/assets/map.gif') + ')'}">
    <div class="hide-overflow" style="position: relative;">
      <v-navigation-drawer absolute temporary v-model="drawer">
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="`navdrawer${i}`">
            <v-list-tile-action>
              <v-icon left v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <router-link :to="item.route" tag="span" style="cursor:pointer">
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </router-link>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

      </v-navigation-drawer>
      <v-toolbar
        app
        absolute
        color="orange darken-3"
        dark
        scroll-off-screen
        scroll-target="#scrolling-techniques"
        extended
        extension-height="20px"
      >

        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-btn light round style="margin-top: 15px">
          <v-img
            width="200px"
            :src="require('@/assets/logo.gif')"
          ></v-img>
        </v-btn>
        <v-toolbar-title class="white--text" style="margin-top: 20px">
        </v-toolbar-title>
          <v-spacer></v-spacer>
        <v-btn light round style="margin-top: 15px; font-size: 20px"><v-icon>phone_android</v-icon>&nbsp;&nbsp; +7(962)684-9495 &nbsp;&nbsp;<v-icon>location_on</v-icon></v-btn>

      </v-toolbar>
      <div
        id="scrolling-techniques"
        class="scroll-y"
        style="max-height: 1000px;"
      >
        <v-container style="height: 1200px;">
          <v-card  class="hidden-sm-and-down" max-width="1800" style="background: rgb(0,0,0,0.3)">
            <v-img
              :src="require('@/assets/fura.gif')"
              max-width="1200"
              style="margin-top: 50px; margin-left: 3%;"
            >
              <router-link :to="{path:'/about'}" tag="span" style="cursor:pointer">
                <v-img
                  :src="require('@/assets/cargo.gif')"
                  width="15%"
                  style="position: absolute; left: 20%;"
                  :class="[$route.fullPath === '/about'?'cargo_down':'cargo_up']"
                >
                  <div class="cargo_text">
                    О КОМПАНИИ
                  </div>
                </v-img>
              </router-link>

              <router-link :to="{path:'/service'}" tag="span" style="cursor:pointer">
                <v-img
                  :src="require('@/assets/cargo.gif')"
                  width="15%"
                  style="position: absolute; left: 35%;"
                  :class="[$route.fullPath === '/service'?'cargo_down':'cargo_up']"
                >
                  <div class="cargo_text">
                    ГУЗОПЕРЕВОЗКИ
                  </div>
                </v-img>
              </router-link>

              <router-link :to="{path:'/custom'}" tag="span" style="cursor:pointer">
                <v-img
                  :src="require('@/assets/cargo.gif')"
                  width="15%"
                  style="position: absolute; left: 50%;"
                  :class="[$route.fullPath === '/custom'?'cargo_down':'cargo_up']"
                >
                  <div class="cargo_text">
                    ТАМОЖЕННОЕ ОФОРМЛЕНИЕ
                  </div>
                </v-img>
              </router-link>

              <router-link :to="{path:'/docs'}" tag="span" style="cursor:pointer">
                <v-img
                  :src="require('@/assets/cargo.gif')"
                  width="15%"
                  style="position: absolute; left: 65%;"
                  :class="[$route.fullPath === '/docs'?'cargo_down':'cargo_up']"
                >
                  <div class="cargo_text">
                    ДОКУМЕНТЫ
                  </div>
                </v-img>
              </router-link>

              <router-link :to="{path:'/outsource'}" tag="span" style="cursor:pointer">
                <v-img
                  :src="require('@/assets/cargo.gif')"
                  width="15%"
                  style="position: absolute; left: 80%;"
                  :class="[$route.fullPath === '/outsource'?'cargo_down':'cargo_up']"
                >
                  <div class="cargo_text">
                    АУТСОРСИНГ
                  </div>
                </v-img>
              </router-link>

            </v-img>
          </v-card>
          <v-card>
            <div>
              <router-view/>
            </div>
          </v-card>
        </v-container>
      </div>
    </div>
  </v-app>
</template>

<script>

export default {
  data () {
    return {
      drawer: false
    }
  },
  computed: {
    menuItems () {
      return [
        {
          icon: 'info',
          title: 'О Компании',
          route: '/about'
        },
        {
          icon: 'directions_car',
          title: 'Грузоперевозки',
          route: '/service'
        },
        {
          icon: 'timeline',
          title: 'Таможенное оформление',
          route: '/custom'
        },
        {
          icon: 'folder_open',
          title: 'Документы',
          route: '/docs'
        },
        {
          icon: 'work_outline',
          title: 'Аутсорсинг',
          route: '/outsource'
        },
        {
          icon: 'phone_android',
          title: '+7 (962) 684-9495',
          route: '/contact'
        }
      ]
    }
  }

}
</script>

<style scoped>
  .cargo_text {
    text-align: center;
    margin-top: 10px;
    font-weight: bold;
    color: #1c1cc8;

  }
  .cargo_up {
    // opacity: 1;
    -webkit-transition: 5s ease-in-out;
    transition: 5s ease-in-out;
    top: 30%;
  }
  .cargo_down {
    // opacity: .5;
    -webkit-transition: 5s ease-in-out;
    transition: 5s ease-in-out;
    top: 63%;
  }
  .cargo_up:hover {

  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue